"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFormFieldDto = void 0;
class CustomFormFieldDto {
    constructor(params) {
        this.fieldLabel = "";
        this.responseType = "";
        this.isRequired = false;
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.customFormId = params.customFormId;
        this.fieldLabel = params.fieldLabel;
        this.responseType = params.responseType;
        this.isRequired = params.isRequired;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
    }
}
exports.CustomFormFieldDto = CustomFormFieldDto;
//# sourceMappingURL=CustomFormFieldDto.js.map